import React from 'react';
import { Redirect } from 'react-router';

import { useAuth, Permissions } from '../../app/AuthorizationProvider';
import { PATH_MY_SCHEDULE_MONTHLY, PATH_FORECASTING_STUDIO } from '../../router/routes';

export const DashboardScene: React.FC = () => {
  const { userHasPermissions } = useAuth();

  const hasUserAgentRole = userHasPermissions([Permissions.ViewAgentSchedule]);

  if (hasUserAgentRole) {
    return <Redirect to={PATH_MY_SCHEDULE_MONTHLY} />;
  }

  // redirect to Forecasting Studio will be replaced with dashboard view for schedulers/analysts
  return <Redirect to={PATH_FORECASTING_STUDIO} />;
};
